/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from "react-router-dom";
import {getEnteralFormulaProductNotesPromise} from "../../../../../services/neofaxPediatricsService";
import {
    fetchAndSaveProductNotes, removeProductNote, selectFormulaDocIds, selectFormulaNotes
} from "./redux/enteral_formula_product_notes_redux";
import {areArraysEqual} from "../../../../../utils";
import {CommonFooter} from "../../../../../components/common/footers/Footer";
import CommonOverflowModalPopups from "../../../../../components/common-overflow-menu/CommonOverflowModalPopups";
import {SelectedItem} from "../../../../../components/common/SelectedItem";
import {get} from "../../../../../utils";
import {SECTION_TYPE_FORMULAS, NEOPED_URL} from "../../../common/constants";
import {makeDeleteSelectedFormulaThunk} from "../SearchPage/redux/formula_search_redux";
import {SectionTabsForNavigation, TitleHeader} from "../../../common/components";
import {ModifySearchHeader} from "../NutrientDetailsPage/components/ModifySearchHeader";
import {
    TITLE_ENTERAL_FORMULAS_PRODUCT_NOTES
} from "../../../../../components/common/constants";


export const ProductNotesPage = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const scrollingDivRef = useRef(null);
    const loc_search = get(props, "location.search", {});

    const searchParams = new URLSearchParams(loc_search);
    const docIds = searchParams.get("docIds")?.split(",") || [];
    const resultType = searchParams.get("resultType")?.split(",") || "";
    const login_page = useSelector((state) => state.login_page);
    const productNotes = useSelector((state) => selectFormulaNotes(state)(resultType));
    const productNotesDocIds = useSelector((state) => selectFormulaDocIds(state)(resultType));

    const getProductNotesNames = () => {
        const productNotesMap = new Map();
        productNotes.forEach((noteDetails) => {
            productNotesMap.set(noteDetails.docId, noteDetails.title);
        });
        return productNotesMap;
    }

    useEffect(() => {
        document.title = TITLE_ENTERAL_FORMULAS_PRODUCT_NOTES;
    }, []);

    useEffect(() => {
        if (!areArraysEqual(docIds, productNotesDocIds)) {
            dispatch(fetchAndSaveProductNotes({
                fetcher: () => getEnteralFormulaProductNotesPromise({result_type: resultType, docIds, login_page}),
                result_type: resultType,
                docIds: docIds,
                history,
                loginPage: login_page,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docIds]);

    const topicsWithHr = [
        'subHeaderKey',
        'subHeader2Key',
        'ironNotationKey',
        'carbohydrateSourceKey',
        'dataReferencesKey'
    ];

    const handleRemoveNote = (docId) => {
        if (productNotes.length === 1) {
            return;
        }
        dispatch(removeProductNote({result_type: resultType, docId}));
        dispatch(makeDeleteSelectedFormulaThunk(docId));
        const newDocIds = docIds.filter(id => id !== docId);
        history.push(`${props.location.pathname}?resultType=${resultType}&docIds=${newDocIds.join(',')}`);
    };

    const modifySearchUrl = `${NEOPED_URL}?tab=${resultType}&section=${SECTION_TYPE_FORMULAS}`;
    return (
        <div ref={scrollingDivRef} className="main-container neofax-product-notes-container">
            <div className="empty-container"></div>
            <div className="main-content">
                <div
                    className="mdx-scroll-area mdx-scroll-area-ie"
                    data-testid="enteral-formula-product-notes-container"
                >
                    <SectionTabsForNavigation/>
                    <ModifySearchHeader modifySearchUrl={modifySearchUrl} resultType={resultType} section={SECTION_TYPE_FORMULAS}/>
                    <TitleHeader
                      subTitle="NeoFax® / Pediatrics"
                      mainTitle="Product Notes"
                    />
                    <div className="enteral-product-notes-search-section">
                        <div className="search-title">
                            <h5>Formula Search</h5>
                        </div>
                        <div className="selected-items-container">
                        {Array.from(getProductNotesNames().entries()).map(([docId, title], index) => (
                            <div className="enteral-product-notes-submitted-search-box">
                                <div className="enteral-product-notes-selected-item-container">
                                    <SelectedItem
                                        long_name={title}
                                        key={index}
                                        click_handler={() => handleRemoveNote(docId)}
                                        shouldShowCloseIcon={productNotes.length !== 1}
                                        // waiting_flag = {this.props.diSummaryPageResponseLoading.status}
                                    />
                                </div>
                            </div>
                        ))}
                        </div>
                    </div>
                    <div className="product-note-content">
                        {productNotes.map((noteDetails, noteDetailsIndex) => (
                            <React.Fragment key={noteDetailsIndex}>
                                <div key={noteDetails.docId}>
                                    <h4 className="product-note-title">{noteDetails.title}</h4>
                                    <ul>
                                        {noteDetails.content.map((contentItem, contentItemIndex) => (
                                            <React.Fragment key={contentItemIndex}>
                                                <li key={contentItemIndex} className={`product-note-section ${contentItem.sectionKey === "dilutionTableKey" ? "table-container" : ""}`}>
                                                    <span dangerouslySetInnerHTML={{__html: contentItem.value}}/>
                                                </li>
                                                {(topicsWithHr.includes(contentItem.sectionKey) &&
                                                        (contentItem.sectionKey !== "dataReferencesKey" || noteDetailsIndex === productNotes.length - 1)) &&
                                                    <hr className="product-notes-section-separator" />}
                                            </React.Fragment>
                                        ))}
                                    </ul>
                                </div>
                                {noteDetailsIndex !== productNotes.length - 1 &&
                                    <hr className="product-notes-separator"
                                        style={{height: '10px', background: 'black'}}/>}
                            </React.Fragment>
                        ))}
                    </div>
                    <CommonFooter/>
                </div>

            </div>

            <CommonOverflowModalPopups/>
        </div>
    );
};
